import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ActionScope } from '../../../shared/action/ActionModel';
import { gameStore } from '../../stores/GameStore';
import { itemStore } from '../../stores/ItemStore';
import { TextPartType, TextParser } from "./TextParser";
const ErrorSpan = styled.span.withConfig({
  displayName: "DialogueParser__ErrorSpan",
  componentId: "sc-wft25z-0"
})(["font-weight:bold;color:red;"]);
export const findVariableValue = (dialoguePart, rootActionTree, treeScopeContext) => {
  const {
    languageKey
  } = gameStore; // We do not know the scope/type, so we try things in order
  // 1. Local variable

  let variableValue = gameStore.gameEngine.gameState.getVariable(dialoguePart, ActionScope.Tree, rootActionTree, treeScopeContext);

  if (!variableValue) {
    // 2. Global Variable
    variableValue = gameStore.gameEngine.gameState.getVariable(dialoguePart, ActionScope.Global, rootActionTree, treeScopeContext);
  }

  if (!variableValue && gameStore.gameEngine.gameState.playerInventory.has(dialoguePart)) {
    // 3. Item - TODO should this be here at all?
    variableValue = itemStore.getItem(dialoguePart).name.get(languageKey);
  }

  return variableValue;
};
export const DialogueParser = observer(({
  dialogueString,
  initialTreeScopeContext
}) => {
  var _parser$textParts;

  const {
    t
  } = useTranslation();
  const parser = new TextParser();
  parser.parseString(dialogueString, initialTreeScopeContext, t);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_parser$textParts = parser.textParts) === null || _parser$textParts === void 0 ? void 0 : _parser$textParts.map((part, index) => {
    // Reassemble parts by mapping them to JSX elements
    switch (part.type) {
      case TextPartType.Highlight:
        return /*#__PURE__*/React.createElement("strong", {
          key: index
        }, part.content);

      case TextPartType.Italic:
        return /*#__PURE__*/React.createElement("i", {
          key: index
        }, part.content);

      case TextPartType.ItalicHighlight:
        return /*#__PURE__*/React.createElement("strong", {
          key: index
        }, /*#__PURE__*/React.createElement("i", null, part.content));

      case TextPartType.Error:
        return /*#__PURE__*/React.createElement(ErrorSpan, {
          key: index
        }, part.content);

      default:
        // DialoguePartType.Regular:
        return /*#__PURE__*/React.createElement("span", {
          key: index
        }, part.content);
    }
  }));
});